/*eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Table,
  Dropdown,
  Input,
} from "semantic-ui-react";
import {
  Formik, Form as Formiker,
  Field as Fieldmik,
} from 'formik';
import { MyInput, MyNormalInput, MyNumInput } from "../dynamicComponent/myInputs";
import { connect } from "react-redux";
import { createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from '../axiosComponent/create';
import * as yup from "yup";
import ErrorMessages from "../createShipmentComponent/ErrorMessages";
import { successAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import DropLocation from "../dynamicComponent/locationDrop";
import ModalCreateConsignee from "../createShipmentComponent/modalCreateConsignee";
import ModalCreateConsignor from "../createShipmentComponent/modalCreateConsigner";
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import MyConsigneeComponent from "../dynamicComponent/consignee";
import MyConsignor from "../dynamicComponent/consignor";
import MyVendorComponent from "../dynamicComponent/vendorSearch";
import MyBillingPartyComponent from "../dynamicComponent/billingparty";
import ReadMasterAxios from '../axiosComponent/readMaster';
import moment from 'moment';
import CreatAxios from "../axiosComponent/create";

const VGenerateOrder = (props, { setFieldValue }) => {
  const getIntialCall = async () => {
    let [productsArray, dataArray, serviceArray, loadArray, branchArray] = await Promise.all([
      ReadAxios({ url: "skuMaster" }),
      ReadAxios({ url: `vehicleTypeMaster` }),
    ]);
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    serviceArray = isEmpty(serviceArray) ? [] : serviceArray.data;
    loadArray = isEmpty(loadArray) ? [] : loadArray.data;
    productsArray = isEmpty(productsArray) ? [] : productsArray.data.resultSet;

    if (branchArray)
      setbranchArray(
        branchArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.branchName,
            value: item.branchId,
            raw: { ...item },
          };
        })
      );

    if (dataArray)
      setvehicletype(
        dataArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.vehicleType + " " + "(" + item.vehicleTypeTonnage + ")",
            value: item.vehicleTypeId,
            raw: { ...item },
          };
        })
      );

    if (productsArray) {
      setproducts(
        productsArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.skuCode,
            value: item.skuCode,
            raw: { ...item },
          };
        })
      );
    }
  };

  const [consignees, setconsignees] = useState([]);
  const [consignors, setconsignors] = useState([]);
  const [products, setproducts] = useState([]);
  const [vehicles, setvehicletype] = useState([]);
  const [ownership, setownershiptype] = useState([]);
  const [customertype, setcustomertype] = useState([]);
  const [billingparty, setBillingParty] = useState([]);
  const [billingpartybranch, setBillingPartyBranch] = useState([]);
  const [branchs, setbranchArray] = useState([]);
  const [userbranchs, setUserbranchArray] = useState([]);
  const [ownvendor, setOwnVendor] = useState([]);
  const [service, setService] = useState([]);
  const [load, setLoad] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [checkowner, setcheckowner] = useState(2);

  useEffect(() => {
    getServiceType();
    getOwnershipType();
    getCustomerType();
    getBranch();
    getLoadType();
    getIntialCall();
    getCurrentUserBranch();
    getOwnVendors();
  }, []);

  const getOwnVendors = () => {
    CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster` })
      .then((result) => {
        let tempown = [];
        let vendorData = result.data.resultSet;
        for (let index = 0; index < vendorData.length; index++) {
          if (vendorData[index].vendorOwnershipType == 1) {
            tempown.push(vendorData[index]);
          }
        }
        setOwnVendor(
          tempown.map((item, index) => {
            return {
              key: index + 1,
              text: item.transporterName,
              value: item.transporterMasterId,
              raw: { ...item },
            };
          })
        );
        console.log('o', tempown);
      })
  }



  const getCurrentUserBranch = () => {
    let temparray = localStorage.getItem('branchIds');
    ReadAxios({
      url: `branch`, mainUserId: Number(localStorage.getItem('userId'))
    })
      .then((res) => {
        setLoading(false);
        let branchArray = res.data.resultSet;
        if (temparray != "") {
          let temp = temparray.split(',');
          let tempa = [];
          for (let index = 0; index < branchArray.length; index++) {
            for (let indexj = 0; indexj < temp.length; indexj++) {
              if (branchArray[index].branchId == +temp[indexj]) {
                tempa.push(branchArray[index]);
              }
            }
          }
          setUserbranchArray(
            tempa.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        } else {
          setUserbranchArray(
            branchArray.map((item, index) => {
              return {
                key: index + 1,
                text: `${item.branchName} (${item.branchCode})`,
                value: item.branchId,
                raw: { ...item },
              };
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }

  const checkOwnership = (data) => {
    console.log('ownership', data.value);
    setcheckowner(data.value)
  }

  const getBranch = () => {
    ReadAxios({
      url: `branch`, mainUserId: Number(localStorage.getItem('userId'))
    })
      .then((res) => {
        console.log('branch deliver to', res.data);
        setLoading(false);
        let branchArray = res.data.resultSet;
        setbranchArray(
          branchArray.map((item, index) => {
            return {
              key: index + 1,
              text: item.branchName,
              value: item.branchName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

  }
  const getServiceType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/service/type`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        setLoading(false);
        let service = res.data.data;
        setService(
          service.map((item, index) => {
            return {
              key: index,
              value: item.service_type_id,
              text: item.service_type_name,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getOwnershipType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`,
    })
      .then((res) => {
        setLoading(false);
        console.log(res.data);
        let ownership = res.data.resultSet;
        setownershiptype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.vehicleOwnershipTypeId,
              text: item.vehicleOwnershipTypeName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getCustomerType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billingPartyPaymentType`,
    })
      .then((res) => {
        setLoading(false);
        console.log(res.data);
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getBillingParty = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party`,
    })
      .then((res) => {
        setLoading(false);
        console.log(res.data);
        let ownership = res.data.resultSet;
        setBillingParty(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyId,
              text: item.billingPartyName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }


  const checkBillingParty = (name, data) => {
    let btemparray = localStorage.getItem('billingpartbranchIds');
    ReadMasterAxios({ completeURLL: `${process.env.REACT_APP_MASTER_API}/billing_party_branch`, mainUserId: Number(localStorage.getItem("userId")), billingPartyId: data.value, }).then((response) => {
      console.log('getBranchBillingData', response.data);
      let options = response.data.resultSet;
      if (btemparray != "") {
        let btemp = btemparray.split(',');
        let btempa = [];
        console.log('full');
        for (let index = 0; index < options.length; index++) {
          for (let indexj = 0; indexj < btemp.length; indexj++) {
            if (options[index].billingPartyId == +btemp[indexj]) {
              btempa.push(branchArray[index]);
            }
          }
        }
        setBillingPartyBranch(
          btempa.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyBranchId,
              text: item.billingPartyBranchName,
              raw: { ...item },
            };
          }))
      } else {
        console.log('empty');
        setBillingPartyBranch(
          options.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyBranchId,
              text: item.billingPartyBranchName,
              raw: { ...item },
            };
          }))
      }
      setBillingPartyBranch(
        options.map((item, index) => {
          return {
            key: index,
            value: item.billingPartyBranchId,
            text: item.billingPartyBranchName,
            raw: { ...item },
          };
        }))
    }).catch((error) => console.log(error))
  }

  const getLoadType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`,
    })
      .then((res) => {
        setLoading(false);
        let load = [];

        let loadtypeRes = res.data.data

        if (localStorage.getItem('customerNumber') == 549) {
          loadtypeRes.forEach(element => {
            if (element.load_type_name == "Frozen") {
              element.load_type_name = 'Reefer'
            }
          });
          let newLoadType = loadtypeRes.filter((type) => {
            if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
              return type
            }
          })

          load = newLoadType;
        }
        else {
          load = loadtypeRes;
        }

        setLoad(
          load.map((item, index) => {
            return {
              key: index,
              value: item.load_type_id,
              text: item.load_type_name,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const addNewDelivery = (arrayHelpers) => {
    if (props.shipment.create.movement_type == "import") {
      if (props.shipment.create.no_of_vehicles <= arrayHelpers.form.values.deliveries.length) {
        console.log('container number is less than deliveries');
      } else {
        arrayHelpers.push({
          delivery_number: "",
          delivery_reference_no: null,
          transporter_lr_no: null,
          lr_date: moment(props.reqon).add(props.btime, 'h').toDate(),
          lr_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
          actual_weight: null,
          gross_weight: null,
          charged_weight: null,
          customer_type_id: null,
          billing_party_id: null,
          billing_party_branch_id: null,
          billing_party_branch_name: "",
          deliver_to: "consignee",
          deliver_to_branch_id: null,
          deliver_to_address: null,
          consignor_code: "",
          consignor_name: "",
          consignee_code: "",
          consignee_name: "",
          consignee_address: "",
          consignor_address: "",
          min_temp: null,
          max_temp: null,
          container_no: null,
          container_type: null,
          container_pickup_date: props.reqon,
          container_pickup_date_t: props.reqon,
          delivery_date: moment(props.reqon).add(props.btime, 'h').toDate(),
          delivery_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
          products: [
            {
              product_code: null,
              product_name: null,
              quantity: null,
              product_category_id: null,
              packaging_type_id: null,
              invoice_no: null,
            },
          ],
          invoices: [
            {
              invoice_no: null,
              invoice_date: null,
              invoice_quantity: null,
              invoice_amount: null,
              bl_no: null
            }
          ],
        })
      }
    } else {
      arrayHelpers.push({
        delivery_number: "",
        delivery_reference_no: null,
        transporter_lr_no: null,
        lr_date: moment(props.reqon).add(props.btime, 'h').toDate(),
        lr_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
        actual_weight: null,
        gross_weight: null,
        charged_weight: null,
        customer_type_id: null,
        billing_party_id: null,
        billing_party_branch_id: null,
        deliver_to: "consignee",
        deliver_to_branch_id: null,
        billing_party_branch_name: "",
        deliver_to_address: null,
        other: null,
        consignor_code: "",
        consignor_name: "",
        consignee_code: "",
        consignee_name: "",
        consignee_address: "",
        consignor_address: "",
        min_temp: null,
        max_temp: null,
        container_no: null,
        container_type: null,
        container_pickup_date: props.reqon,
        container_pickup_date_t: props.reqon,
        delivery_date: moment(props.reqon).add(props.btime, 'h').toDate(),
        delivery_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
        products: [
          {
            product_code: null,
            product_name: null,
            quantity: null,
            product_category_id: null,
            packaging_type_id: null,
            invoice_no: null,
          },
        ],
        invoices: [
          {
            invoice_no: null,
            invoice_date: null,
            invoice_quantity: null,
            invoice_amount: null,
            bl_no: null
          }
        ],
      })
    }
  }

  const decideInitialValue = {
    // order_number: "",
    order_reference_no: null,
    gross_weight: 1,
    net_weight: 1,
    proposed_vehicle_type: "",
    ownership_type_id: 2,
    proposed_vehicle_type_name: "",
    vendor_id: undefined,
    vendor_name: "",
    vehicle_number: "",
    booking_branch_id: null,
    booking_branch_name: "",
    freight_rate: "0",
    service_type_id: 1,
    load_type_id: 4,
    deliveries: [
      {
        delivery_number: "",
        delivery_reference_no: null,
        transporter_lr_no: null,
        lr_date: moment(props.reqon).add(props.btime, 'h').toDate(),
        lr_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
        actual_weight: null,
        gross_weight: null,
        charged_weight: null,
        customer_type_id: null,
        billing_party_id: null,
        billing_party_branch_id: null,
        deliver_to: "consignee",
        deliver_to_branch_id: null,
        billing_party_branch_name: "",
        deliver_to_address: null,
        other: null,
        consignor_code: "",
        consignor_name: "",
        consignee_code: "",
        consignee_name: "",
        consignee_address: "",
        consignor_address: "",
        min_temp: null,
        max_temp: null,
        container_no: null,
        container_pickup_date: props.reqon,
        container_pickup_date_t: props.reqon,
        delivery_date: moment(props.reqon).add(props.btime, 'h').toDate(),
        delivery_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
        container_drop_location: null,
        storage_expiration_date: null,
        storage_expiration_date_t: null,
        container_type: null,
        demurrage_expiration_date: null,
        demurrage_expiration_date_t: null,
        ata_date: null,
        ata_date_t: null,
        products: [
          {
            product_code: null,
            product_name: null,
            quantity: null,
            product_category_id: null,
            packaging_type_id: null,
            invoice_no: null,
          },
        ],
        invoices: [
          {
            invoice_no: null,
            invoice_date: null,
            invoice_quantity: null,
            invoice_amount: null,
            bl_no: null
          }
        ],
      },
    ],
  };

  var validationSchema = yup.object().shape(
    {
      // order_number: yup.string().optional(),
      order_reference_no: yup.string().nullable().optional(),
      gross_weight: yup
        .number()
        .required("required")
        .min(1, "min")
        .when("net_weight", (net_weight) =>
          net_weight
            ? yup.number().optional().nullable().min(net_weight, "min_net")
            : yup.number().required("required").min(1, "min")
        ),
      net_weight: yup
        .number()
        .required("required")
        .min(1, "min")
        .when("gross_weight", (gross_weight) =>
          gross_weight
            ? yup.number().optional().nullable().max(gross_weight, "max_gross")
            : yup.number().required("required").min(1, "min")
        ),
      proposed_vehicle_type: yup.number().required("required"),
      ownership_type_id: yup.number().optional().nullable(),
      booking_branch_id: yup.number().optional().nullable(),
      vendor_id: yup.number().optional(),
      ownership_type_id: yup.number().optional(),
      freight_rate: yup.number().optional(),
      service_type_id: yup.number().optional(),
      load_type_id: yup.number().optional(),
      deliveries: yup.array().of(
        yup.object().shape(
          {
            delivery_number: yup.string().optional(),
            delivery_reference_no: yup.string().nullable().optional(),
            transporter_lr_no: yup.string().nullable().optional(),
            lr_date: yup.string().nullable().optional(),
            lr_date_t: yup.string().nullable().optional(),
            actual_weight: yup.number().nullable().optional(),
            gross_weight: yup.number().nullable().optional(),
            charged_weight: yup.number().nullable().optional(),
            customer_type_id: yup.number().nullable().optional(),
            billing_party_id: yup.number().nullable().optional(),
            billing_party_branch_id: yup.number().nullable().optional(),
            deliver_to: yup.string().nullable().optional(),
            deliver_to_branch_id: yup.number().nullable().optional(),
            deliver_to_address: yup.string().nullable().optional(),
            other: yup.string().nullable().optional(),
            consignor_code: yup.string().required("required"),
            consignee_code: yup.string().required("required"),
            consignee_address: yup.string().nullable().optional(),
            consignor_address: yup.string().nullable().optional(),
            min_temp: yup
              .number()
              .optional()
              .nullable()
              .when("max_temp", (max_temp) =>
                max_temp
                  ? yup.number().optional().nullable().max(max_temp, "max")
                  : yup.number().optional().nullable()
              ),
            max_temp: yup
              .number()
              .optional()
              .nullable()
              .when("min_temp", (min_temp) =>
                min_temp
                  ? yup.number().optional().nullable().min(min_temp, "min")
                  : yup.number().optional().nullable()
              ),
            container_no: yup.string().optional().nullable(),
            container_pickup_date: yup
              .string()
              .optional()
              .nullable(),
            container_pickup_date_t: yup
              .string()
              .optional()
              .nullable(),
            delivery_date: yup.string().optional().nullable(),
            delivery_date_t: yup.string().optional().nullable(),
            container_drop_location: yup.string().optional().nullable(),
            storage_expiration: yup.string().optional().nullable(),
            container_type: yup.string().optional().nullable(),
            demurrage_expiration: yup.string().optional().nullable(),
            ata_date: yup.string().optional().nullable(),
            products: yup.array().of(
              yup.object().shape({
                // product_code: yup.string().required("required"),
                product_code: yup.string().optional().nullable(),
                product_name: yup.string().optional().nullable(),
                product_category_id: yup.number().optional().nullable(),
                packaging_type_id: yup.number().optional().nullable(),
                quantity: yup.number().optional().min(1, "min").nullable(),
                // quantity: yup.number().required("required").min(1, "min"),
              })
            ),
            invoices: yup.array().of(
              yup.object().shape({
                invoice_code: yup.string().optional().nullable(),
                invoice_date: yup.string().optional().nullable(),
                invoice_quantity: yup.number().optional().min(1, "min").nullable(),
                invoice_amount: yup.number().optional().nullable(),
              })
            ),
          },
          ["max_temp", "min_temp"]
        )
      ),
    },
    ["net_weight", "gross_weight"]
  );

  return (
    <div>
      <Modal
        open={props.OpenModal}
        size="fullscreen"
        centered={false}
        scrolling="true"
        closeOnDimmerClick={false}
        onClose={props.CloseModal}
      >
        {console.log('check state in modal', props)}
        <Modal.Header className="p-bold-100">
          {"Generate Order"}
        </Modal.Header>
        <Formik
          initialValues={{
            shipment_reference_no: "",
            required_on: new Date(),
            vehicle_availability_id: null,
            route_code: "",
            route_name: "",
            import_declaration_no: "",
            boarding_no: "",
            source: "",
            destination: "",
            budgeted_kms: 0,
            budgeted_time: 0,
            no_of_vehicles: "",
            movement_type: "primary",
            order: [{
              order_reference_no: null,
              gross_weight: 1,
              net_weight: 1,
              proposed_vehicle_type: "",
              ownership_type_id: 2,
              proposed_vehicle_type_name: "",
              vendor_id: undefined,
              vendor_name: "",
              vehicle_number: "",
              booking_branch_id: null,
              booking_branch_name: "",
              freight_rate: "0",
              service_type_id: 1,
              load_type_id: 4,
              deliveries: [
                {
                  delivery_number: "",
                  delivery_reference_no: null,
                  transporter_lr_no: null,
                  lr_date: moment(props.reqon).add(props.btime, 'h').toDate(),
                  lr_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
                  actual_weight: null,
                  gross_weight: null,
                  charged_weight: null,
                  customer_type_id: null,
                  billing_party_id: null,
                  billing_party_branch_id: null,
                  deliver_to: "consignee",
                  deliver_to_branch_id: null,
                  billing_party_branch_name: "",
                  deliver_to_address: null,
                  other: null,
                  consignor_code: "",
                  consignor_name: "",
                  consignee_code: "",
                  consignee_name: "",
                  consignee_address: "",
                  consignor_address: "",
                  min_temp: null,
                  max_temp: null,
                  container_no: null,
                  container_pickup_date: props.reqon,
                  container_pickup_date_t: props.reqon,
                  delivery_date: moment(props.reqon).add(props.btime, 'h').toDate(),
                  delivery_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
                  container_drop_location: null,
                  storage_expiration_date: null,
                  storage_expiration_date_t: null,
                  container_type: null,
                  demurrage_expiration_date: null,
                  demurrage_expiration_date_t: null,
                  ata_date: null,
                  ata_date_t: null,
                  products: [
                    {
                      product_code: null,
                      product_name: null,
                      quantity: null,
                      product_category_id: null,
                      packaging_type_id: null,
                      invoice_no: null,
                    },
                  ],
                  invoices: [
                    {
                      invoice_no: null,
                      invoice_date: null,
                      invoice_quantity: null,
                      invoice_amount: null,
                      bl_no: null
                    }
                  ],
                },
              ],
            }],
          }}
          onSubmit={async (values) => {
            console.log(values);
            await new Promise((r) => setTimeout(r, 500));
            values.vehicle_availability_id = props.data.vehicle_availability_id
            let shipment = {
              shipment_reference_no: null,
              required_on: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              vehicle_availability_id: props.data.vehicle_availability_id,
              route_code: values.route_code,
              route_name: "",
              import_declaration_no: null,
              boarding_no: null,
              source: values.source,
              destination: values.destination,
              budgeted_kms: values.budgeted_kms,
              budgeted_time: values.budgeted_time,
              no_of_vehicles: 1,
              movement_type: "primary",
              orders: [{
                order_reference_no: null,
                gross_weight: values.gross_weight,
                net_weight: 1,
                proposed_vehicle_type: props.data.vehicle_type_id,
                ownership_type_id: 2,
                proposed_vehicle_type_name: props.data.vehicle_type,
                vendor_id: props.data.vendor_id,
                vendor_name: props.data.vendor_name,
                vehicle_number: props.data.vehicle_number,
                booking_branch_id: null,
                booking_branch_name: "",
                freight_rate: values.freight_rate,
                service_type_id: 1,
                load_type_id: props.data.load_type_id,
                deliveries: [
                  {
                    delivery_number: "",
                    delivery_reference_no: null,
                    transporter_lr_no: null,
                    lr_date: moment(props.reqon).add(props.btime, 'h').toDate(),
                    lr_date_t: moment(props.reqon).add(props.btime, 'h').toDate(),
                    actual_weight: null,
                    gross_weight: null,
                    charged_weight: null,
                    customer_type_id: null,
                    billing_party_id: null,
                    billing_party_branch_id: null,
                    deliver_to: "consignee",
                    deliver_to_branch_id: null,
                    billing_party_branch_name: "",
                    deliver_to_address: values.deliver_to_address,
                    other: null,
                    consignor_code: values.consignor_code,
                    consignor_name: "",
                    consignee_code: values.consignee_code,
                    consignee_name: "",
                    consignee_address: "",
                    consignor_address: "",
                    min_temp: props.data.min_temp,
                    max_temp: props.data.max_temp,
                    container_no: null,
                    container_pickup_date: values.required_on,
                    container_pickup_date_t: values.required_on,
                    delivery_date: moment(values.required_on).add(values.budgeted_time, 'h').toDate(),
                    delivery_date_t: moment(values.required_on).add(values.budgeted_time, 'h').toDate(),
                    container_drop_location: null,
                    storage_expiration_date: null,
                    storage_expiration_date_t: null,
                    container_type: null,
                    demurrage_expiration_date: null,
                    demurrage_expiration_date_t: null,
                    ata_date: null,
                    ata_date_t: null,
                    products: [
                      {
                        product_code: values.product_code,
                        product_name: values.product_name,
                        quantity: null,
                        product_category_id: values.product_category_id,
                        packaging_type_id: values.packaging_type_id,
                        invoice_no: null,
                      },
                    ],
                    invoices: [],
                  },
                ],
              }],
            }
            console.log('LKJ', shipment);
            CreatAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments`,
              payload: { ...shipment },
            })
              .then((res) => {
                let alert = {
                  type: "success",
                  messageHeader: "Success",
                  messageBody: 'Order Created',
                };
                props.CloseModal(alert);
              })
              .catch((err) => {
                console.log('check', err);
                let alert = {
                  type: "error",
                  messageHeader: "Error",
                  messageBody: typeof (err.response.data.message) == "object" ? err.response.data.message[0] : err.response.data.message,
                };
                props.error(alert)
              });
          }}
          render={({ values, setFieldValue, errors, touched, t }) => {
            const setSourceDestination = async (name, value) => {
              if (value) {
                const { key, raw } = value;
                let checkPointsArray = await ReadAxios({
                  url: `routeManager/${raw.routeMasterId}`,
                });
                checkPointsArray = isEmpty(checkPointsArray)
                  ? []
                  : checkPointsArray.data.resultSet;
                setFieldValue(name, key);
                setFieldValue("source", checkPointsArray[0].checkPointName);
                setFieldValue(
                  "destination",
                  checkPointsArray[checkPointsArray.length - 1].checkPointName
                );
                setFieldValue("budgeted_kms", checkPointsArray[0].budgetedKms);
                setFieldValue(
                  "budgeted_time",
                  checkPointsArray[checkPointsArray.length - 1].budgetedTime
                );
              } else {
                setFieldValue(name, value);
                setFieldValue("source", "");
                setFieldValue("destination", "");
                setFieldValue("budgeted_kms", null);
                setFieldValue("budgeted_time", null);
              }
            };
            const setProductCodeAndProductName = (name, data, productname) => {
              setFieldValue(data.name, data.value);
              setFieldValue(
                productname,
                data.options.find((ele) => ele.value == data.value)
                  ? data.options.find((ele) => ele.value == data.value).raw
                    .skuName
                  : ""
              );
            };
            return (
              <Modal.Content scrolling={true}>
                <Modal.Description>
                  <Formiker className="ui form tiny">
                    <FormUi.Group>
                      <FormUi.Field width={2}>
                        <label htmlFor="firstName">Route</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <SearchDropdown
                          setField={setSourceDestination}
                          masterRoute="routeMaster"
                          masterRouteKey="routeCode"
                          masterRouteName="routeName"
                          fieldName="route_code"
                        // deafultValue={values.route_name}
                        />
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={2}>
                        <label htmlFor="lastName">Required On</label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <DateData
                          name="required_on"
                          autoComplete="off"
                          showTimeSelect
                          timeFormat="HH:mm"
                          popperClassName="dateTime"
                          dateFormat="dd/MM/yyyy HH:mm"
                          timeIntervals={5}
                          customInput={
                            <Input
                              icon="time"
                              // className="dateWidth"
                              iconPosition="left"
                            />
                          }
                        />
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Weight"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik
                          component={MyNormalInput}
                          name="gross_weight"
                          type="number"
                          min={0}
                        />
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Consignee"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik name={'consignee_code'} placeholder={"Consignee Code"} address={'deliver_to_address'}
                          component={MyConsigneeComponent} />
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Consignor"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik name={'consignor_code'} placeholder={"Consignor Code"}
                          component={MyConsignor} />
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Final Rate"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik
                          component={MyNormalInput}
                          type="number"
                          name="freight_rate"
                        />
                        {/* component={MyConsignor} /> */}
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Product Code"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Dropdown
                          name={`product_code`}
                          placeholder={"Product Code"}
                          clearable
                          style={{ width: "100%" }}
                          selection
                          search
                          onChange={(name, data) =>
                            setProductCodeAndProductName(
                              name,
                              data, `product_name`
                            )
                          }
                          options={products}
                        />
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Product Name"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Fieldmik
                          type="text"
                          style={{
                            paddingTop: "5.5px",
                          }}
                          label={"Product Name"}
                          name={`product_name`}

                        />
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Product Category"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Dropdown
                          name={`product_category_id`}
                          placeholder={"Product Category"}
                          clearable
                          style={{ width: "100%" }}
                          selection
                          search
                          onChange={(name, data) =>
                            setFieldValue(`product_category_id`, +data.value)
                          }
                          options={[
                            { key: "1", text: "Agro Food/ F&V", value: "1" },
                            { key: "2", text: "Butter", value: "2" },
                            { key: "3", text: "Confectionery", value: "3" },
                            { key: "4", text: "Dairy Products", value: "4" },
                            { key: "5", text: "Healthcare & Pharma", value: "5" },
                            { key: "6", text: "Ice Creams", value: "6" },
                            { key: "7", text: "Industrial Products", value: "7" },
                            { key: "8", text: "Meat", value: "8" },
                            { key: "9", text: "Others", value: "9" },
                            { key: "10", text: "Poultry", value: "10" },
                            { key: "11", text: "Quick Serve Restaurant", value: "11" },
                            { key: "12", text: "RTC (Ready to Cook)", value: "12" },
                            { key: "13", text: "Sea Food", value: "13" },
                            { key: "14", text: "Beverages", value: "14" },
                            { key: "15", text: "RTE (Ready to Eat)", value: "15" },
                          ]}
                        />
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {"Packaging Type"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field width={3}>
                        <Dropdown
                          name={`packaging_type_id`}
                          placeholder={"Packaging Type"}
                          clearable
                          style={{ width: "100%" }}
                          selection
                          search
                          onChange={(name, data) =>
                            setFieldValue(`packaging_type_id`, +data.value)
                          }
                          options={[
                            { key: "1", text: "Carton Box", value: "1" },
                            { key: "2", text: "Gunny Bundle", value: "2" },
                            { key: "3", text: "Loose Cargo", value: "3" },
                            { key: "4", text: "Metal Box", value: "4" },
                            { key: "5", text: "Metal Drum", value: "5" },
                            { key: "6", text: "Plastic Crate", value: "6" },
                            { key: "7", text: "Plastic Drum", value: "7" },
                            { key: "8", text: "Wooden Box", value: "8" },
                          ]}
                        />
                      </FormUi.Field>
                    </FormUi.Group>
                    <center>
                      <Button size="mini" primary type="button" onClick={() => props.closeGO()}>
                        {"Close"}
                      </Button>
                      <Button size="mini" primary type="submit">
                        {props.t("action_button.save") || "Save"}
                      </Button>
                    </center>

                  </Formiker>

                </Modal.Description>
              </Modal.Content>
            );
          }}
        ></Formik>
      </Modal>
    </div >
  );
};


export default translate("create_order")(VGenerateOrder);
